import ModalPopup from './ModalPopup';
import ContentPopup from './ContentPopup';
import ConfirmPopup from './ConfirmPopup';
import Popup from './Popup';


export default ContentPopup;
export {
	ModalPopup,
	ContentPopup,
	ConfirmPopup,
	Popup,
};